.packingGroup {
  display: flex;
  flex-direction: column;
  max-height: 100%;
  flex: 1;
  padding: 16px;
  gap: 20px;
  width: 100%;
}
.pgHeader {
  display: flex;
  gap: 6px;
  justify-content: space-between;
  overflow-x: auto;
}
.pgHeader > .leftPane, .pgHeader > .rightPane {
  align-items: center;
  gap: 16px;
  display: flex;
}
.pgHeader > .rightPane {
  width: fit-content;
  min-width: fit-content;
}
.pgHeader > .leftPane {
  flex: 0;
  min-width: fit-content;
}
.pgBody {
  display: flex;
  width: 100%;
  height: 0;
  flex: 1;
  gap: 20px;
}
.pgBody > .leftPane {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.leftPane {
  flex: 3;
  min-width: 0;
}
.rightPane {
  flex: 2;
  max-width: 40%;
}
.selectAllBoxes {
  flex: 1;
}
.boxes {
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding-right: 5px; /* looks better when scrollbar is visible */
  margin-bottom: 4px;
}
.emptyBoxContainer {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 28px 40px 10px;
  text-align: center;
}
.boxHeader {
  display: flex;
  gap: 12px;
  padding: 10px;
  align-items: center;
}
.boxHeader > label {
  flex: 1;
}
.iconButton {
  color: var(--static-text-standard);
}
.boxItem {
  display: flex;
  gap: 16px;
}
.boxButtons {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.scrollArea, .pgBody > .rightPane {
  overflow: hidden auto;
}
.scrollArea {
  border: 1px solid var(--static-divider-standard);
  border-radius: 12px;
}
.scrollArea::-webkit-scrollbar-track {
  background: transparent;
}
.inputNumber {
  width: 104px;
}
.boxHeaderButtons {
  display: contents;
}
.boxHeaderMenu {
  display: none;
}

@media (max-width: 1270px) {
  .boxHeaderButtons {
    display: none;
  }
  .boxHeaderMenu {
    display: contents;
  }
}
